import { RouteObject } from 'react-router-dom'
import FundLayout from 'layout/fund/FundLayout'
import ErrorBug from 'components/errors/bugs'
import LotteryLandingPage from './lottery'
import LotteryLandingIntro from './lottery/intro'
import LandingLayout from 'layout/landing/LandingLayout'

/**
 * Campaign landings.
 *
 * `/q/<code>` is deliberately short: it is typed into Eitaa posts and direct
 * messages by hand as often as it is copied, and every extra segment is
 * another chance for the code to be dropped. The bare `/q` still renders —
 * a link that lost its code is worth less to us but should not 404 on the
 * person who followed it.
 *
 * Two screens, not one. `/q/<code>` is the pitch — what Hamyan does for a fund
 * manager — and `/q/<code>/demo` is the sample صندوق that backs it up. They are
 * separate routes rather than one component with a flag so the back button
 * works the way a reader expects, and so «چند نفر تا دمو رفتند» is a question
 * the funnel can answer instead of a guess.
 *
 * Public, like every route in this app: there is no ProtectedRoute anywhere,
 * auth is enforced by the first API call 401ing, and these pages make none.
 */
export const landingRoutes: RouteObject[] = [
    // The pitch is full width; the demo keeps the app's phone frame. See
    // `LandingLayout` — `FundLayout` pads `md:px-[35%]`, which is right for a
    // phone screen and wrong for a landing, and silently defeats any width the
    // landing sets for itself.
    {
        path: '/q',
        element: <LandingLayout helmet="صندوق قرعه‌کشی همیان" />,
        errorElement: <ErrorBug />,
        children: [
            { index: true, element: <LotteryLandingIntro /> },
            { path: ':code', element: <LotteryLandingIntro /> },
        ],
    },
    {
        path: '/q',
        element: <FundLayout helmet="صندوق نمونهٔ قرعه‌کشی" />,
        errorElement: <ErrorBug />,
        children: [
            { path: 'demo', element: <LotteryLandingPage /> },
            { path: ':code/demo', element: <LotteryLandingPage /> },
        ],
    },
]
